import Vue from 'vue'
import VueRouter from 'vue-router'
import Auth from '../../components/auth/Auth.vue'
import CheckEmail from '../../components/auth/CheckEmail.vue'
import Replay from '../../components/Replay.vue'

Vue.use(VueRouter)

export default new VueRouter({
  mode: 'history',
  routes: [
    { name: 'auth', path: '/', component: Auth },
    { name: 'check-email', path: '/check-email', component: CheckEmail },
    { name: 'event', path: '/users/:uid/projects/:projectId/sessions/:sessionId/events/:eventNr', component: Replay },
  ],
})
